import { useQuery } from "@tanstack/react-query";
import { getApiAuthCapabilitiesOptions } from "@/api/generated/@tanstack/react-query.gen";
import type { GetApiAuthCapabilitiesResponse } from "@/api/generated/types.gen";

const DEFAULT_CAPABILITIES: GetApiAuthCapabilitiesResponse = {
  canManageCollections: false,
  canManageAssistantKinds: false,
  canPublishAssistants: false,
};

export function useCapabilities() {
  const { data, isLoading, isError, error } = useQuery(getApiAuthCapabilitiesOptions());
  return { capabilities: data ?? DEFAULT_CAPABILITIES, isLoading, isError, error };
}
